import type { BariPrePsychQuestionnaireData } from '@common/validation/customControls/bariPre/bariPrePsychQuestionnaire/v1/bariPrePsychQuestionnaireSchemaV1';
import { CustomControlCode } from '@common/enums';
import { CustomControlRegistry } from '@frontend/components/pages/episodeCategory/customControls/customControlRegistry';
import { initialData } from './bariPrePsychQuestionnaireData';
import { BariPrePsychQuestionnaireEdit } from './BariPrePsychQuestionnaireEdit';
import { BariPrePsychQuestionnaireRead } from './BariPrePsychQuestionnaireRead';

CustomControlRegistry.instance.register<BariPrePsychQuestionnaireData>({
    EditElement: BariPrePsychQuestionnaireEdit,
    ReadElement: BariPrePsychQuestionnaireRead,
    code: CustomControlCode.BariPrePsychQuestionnaire,
    initialData,
    version: 1,
});
